import React, {useContext, useEffect, useState} from "react";
import {RoleContext} from "../context/role-context.jsx";
import {PermissionEnum} from "../../../../../utils/enums/permission-enum.js";
import Button from "../../../../../components/button/button.jsx";

const PermissionFormatter = (props) => {
    const { name, text } = props.data;
    const {lanesSelected, maintenanceSelected, protectionProgramSelected} = useContext(RoleContext);

    const openLanes = () => {
        props.node.setSelected(true);
        props.openModalLanes(true);
    }

    const openModalNoc = () => {
        props.node.setSelected(true);
        props.openModalNoc(true);
    }

    const openModalProgram = () => {
        props.node.setSelected(true);
        props.setModalProgram(true);
    }

    return <>
        <span className={"h-full"}>
            {
                name === PermissionEnum.PASSAGE_RESTRICTED_LANE_ACCESS &&
                <div className="flex items-center gap-2">

                    {text}
                    {
                        lanesSelected.length > 0 &&
                        <Button target={"primary"} className={"!h-[25px]"} onClick={openLanes}>
                            {lanesSelected.length} câmeras especiais selecionadas
                        </Button>
                    }

                    {
                        lanesSelected.length === 0 &&
                        <Button target={"secondary"} className={"!h-[25px]"} onClick={openLanes}>
                            Clique para selecionar câmeras
                        </Button>
                    }
                </div>
            }

            {
                name === PermissionEnum.CAPTURE_PLACE_NOC &&
                <div className="flex items-center gap-2">
                    {text}

                    {
                        maintenanceSelected &&
                        <Button target={"primary"} className={"!h-[25px]"} onClick={openModalNoc}>
                            {maintenanceSelected?.label}
                        </Button>
                    }
                    {
                        !maintenanceSelected &&
                        <Button target={"secondary"} className={"!h-[25px]"} onClick={openModalNoc}>
                            Clique para dar permissão de visualização aos responsáveis por manutenção.
                        </Button>
                    }
                </div>
            }

            {
                name === PermissionEnum.SOS_MANAGE_PROGRAM &&
                <div className="flex items-center gap-2">
                    {text}

                    {
                        protectionProgramSelected.length > 0 &&
                        <Button target={"primary"} className={"!h-[25px]"} onClick={openModalProgram}>
                            {protectionProgramSelected.length} programas selecionados
                        </Button>
                    }
                    {
                        protectionProgramSelected.length === 0 &&
                        <Button target={"secondary"} className={"!h-[25px]"} onClick={openModalProgram}>
                            Clique para selecionar um programa de proteção
                        </Button>
                    }
                </div>
            }

            {
                name !== PermissionEnum.PASSAGE_RESTRICTED_LANE_ACCESS && name !== PermissionEnum.CAPTURE_PLACE_NOC && name !== PermissionEnum.SOS_MANAGE_PROGRAM &&
                props.value
            }
        </span>
    </>
}

export default PermissionFormatter;